import { Link } from 'react-router-dom';

import { getInfo, TruncateWithTooltipFormatter } from '@Components/Grid/components/Table/formatters';

export default function SiteFormatter({ info }) {
  const { row } = getInfo(info)
  const { id: siteId, name } = row.site || {}

  return <Link className='hover:underline' to={`/admin/sites/${siteId}`} >
    <TruncateWithTooltipFormatter value={`[#${siteId}] - ${name}`} />
  </Link>
}
